import React from 'react';
import classnames from 'classnames';
import Tooltip from 'swag-client-common/components/ui/tooltip';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from './toggle.scss';
export const CustomToggle = ({
  onToggle,
  value,
  uncheckedLabel = '',
  checkedLabel = '',
  tooltipText = undefined,
  tooltipClassName = '',
  toggleId = '',
  labelClassName = '',
  toggleClassName = '',
  wrapperClassName = '',
  checkLabelClassName = '',
  faceClassName = '',
  toggleBackgroundClassName = '',
  toggleBackgroundDataAttribute = '',
  color = ''
}) => {
  const inputId = toggleId || tooltipText || checkedLabel || uncheckedLabel || 'toggle';
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.uncheckedLabel, labelClassName, {
      [classes.active]: !value
    })
  }, uncheckedLabel), /*#__PURE__*/React.createElement("div", {
    className: classes.toggleWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toggle, toggleClassName),
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, onToggle)
  }, Boolean(tooltipText) && /*#__PURE__*/React.createElement(Tooltip, {
    direction: "top",
    className: classnames(classes.tooltip, tooltipClassName),
    tooltipText: tooltipText
  }), /*#__PURE__*/React.createElement("input", {
    checked: value,
    onChange: () => onToggle(),
    type: "checkbox",
    name: "toggle",
    id: inputId
  }), /*#__PURE__*/React.createElement("label", {
    className: classnames(classes.checkLabel, checkLabelClassName),
    htmlFor: inputId
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toggleBackground, toggleBackgroundClassName),
    "data-attribute": toggleBackgroundDataAttribute,
    style: {
      backgroundColor: value ? color : 'inherit'
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.face, faceClassName)
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.faceContainer
  }))))), Boolean(checkedLabel) && /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.checkedLabel, labelClassName, {
      [classes.active]: value
    })
  }, checkedLabel));
};